<template>
	<div class="your-campaign">
		<!-- BIG SLOGAN -->
		<div class="container">
      <h1 class="mb-30">{{ $t("project.yourCampaign") }}</h1>
			<p class="crowd-or-rais"><span class="domore-yellow">FUNDRAISING</span></p>
		</div><!-- .container -->
    <!-- ORGANIZATION -->
    <choose-organization :project='project' :errors='errors'></choose-organization>
    <!-- FORM -->
    <fundraising-form :project='project' :submit='submit' :errors='errors' :alert='alert'></fundraising-form>

    <!-- Verify or publish project -->
    <div class="container mt-50">
      <verify-project :project='project'></verify-project>
    </div>

    <div class="container">
      <button @click="$router.push({ name: 'show_fundraising', params: { id: project.id, title: project.title.replace(/ /g, '-') } })" type="button" class="btn btn-default btn-lg mt-20 button-wide-rais">
        {{ $t("project.showBtn") }}
      </button>
    </div>

		<!-- STAR BOX -->
		<div class="container mt-50 mb-50">
			<p class="center"><img src="~assets/img/star.png"></p>
		</div><!-- .container .mt-50 .mb-50 -->
	</div>
</template>

<script>
// API
import projectsApi from '@/api/v1/projects';
// Components
import Alert from '@/components/Alert';
import FundraisingForm from '@/views/Fundraising/Form';
import VerifyProject from '@/components/Project/Verification';
import ChooseOrganization from '@/components/Project/Form/ChooseOrganization';
// Mixins
import showProject from '@/mixins/showProject';
import alert from '@/mixins/alert';

export default {
  mixins: [showProject, alert],
  components: { Alert, FundraisingForm, VerifyProject, ChooseOrganization },
  data() {
    return {
      submit: {
        action: this.editProject,
        processing: false,
      },
    };
  },
  methods: {
    editProject() {
      this.clearAlerts();
      this.submit.processing = true;
      projectsApi.edit(this.project).then(() => {
        this.submit.processing = false;
        this.alert.success = this.$t('project.form.changesSaved');
      })
      .catch((response) => {
        this.submit.processing = false;
        this.alert.error = this.$t('errors.incorrectData');
        const errors = response.response.data;
        this.errors = errors;
        window.scrollTo(0, 0);
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// Edit.vue?001b0ed8